export default __webpack_public_path__ + "9442807518065f199600b89710219f5c.png";